// DatenschutzCheckbox.tsx — DSGVO-02 shared consent checkbox for all lead forms
import { AlertCircle } from "lucide-react";
import type { UseFormRegister, FieldError } from "react-hook-form";
import { readMeta } from "../../lib/tenant-branding";

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>;
  error?: FieldError;
}

export default function DatenschutzCheckbox({ register, error }: Props) {
  const datenschutzUrl = readMeta("x-tenant-datenschutz-url") || "/datenschutz";

  return (
    <div className="mb-4">
      <div className="flex items-start gap-3 py-2 min-h-[44px]">
        <input
          type="checkbox"
          id="pdf-datenschutz"
          {...register("datenschutz")}
          className="mt-1 h-4 w-4 rounded border-neko-dark-3 accent-neko-orange cursor-pointer flex-shrink-0"
          aria-describedby={error ? "consent-error" : undefined}
          aria-required="true"
          aria-invalid={!!error}
        />
        <label
          htmlFor="pdf-datenschutz"
          className="text-sm text-neko-gray leading-relaxed cursor-pointer"
        >
          Ich habe die{" "}
          <a
            href={datenschutzUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-neko-orange underline hover:text-neko-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neko-orange"
          >
            Datenschutzerklärung
          </a>
          {" "}gelesen und stimme der Verarbeitung meiner Daten zu.
        </label>
      </div>
      {error && (
        <div
          id="consent-error"
          role="alert"
          className="flex items-center gap-2 mt-1 text-neko-red text-xs"
        >
          <AlertCircle size={14} aria-hidden="true" />
          {error.message}
        </div>
      )}
    </div>
  );
}
